import React, { Component } from 'react'
import { imageAddress, translate } from '../../utils/useful';
import Modal from '../../components/Modal';
import TextInput from '../../components/inputs/TextInput';
import IconMap from './IconMap';

export default class FileUserViewSingle extends Component {
    state = {
        viewName: '',
        access: [
            { img: '/images/p4.png', name: 'Hossein Mohseni', username: 'mh.mohseni98@gmail.com', role: 'Owner' },
            { img: '/images/p1.png', name: 'Hossein Mohseni', username: 'mh.mohseni98@gmail.com', role: 'Owner' },
            { img: '/images/p5.png', name: 'Hossein Mohseni', username: 'mh.mohseni98@gmail.com', role: 'Owner' },
        ],
        filesPic: ['png', 'jpg', 'jpeg', 'svg'],

    }

    componentDidMount() {
        if (this.props.setHeader) {
            this.props.setHeader({
                'showSettings': false,
                backAction: () => this.props.changeStage('list')
            })
        }
    }

    onShareModal = () => {
        this.confirmshareModal.showModal();
    }

    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }
    render() {
        return (
            <div className='h-100 flexcc'>
                <div className='flexcc p-5 m-5 h-100 flex-column br-20' style={{}}>
                    {/* <img width={50} src='/assets/icons/drive/xml.svg' /> */}
                    <img width={50} src={imageAddress(IconMap[this.props.driveInfo?.extension] ? IconMap[this.props.driveInfo?.extension] : (this.state.filesPic.includes(String(this.props.driveInfo?.address).split('.')[String(this.props.driveInfo?.address).split('.').length - 1]) ? imageAddress(this.props.driveInfo?.address) : '/assets/icons/applets/drive/unknown-file.svg'))} />
                    <p className='mt-2'>{this.props.driveInfo.name}</p>
                    <p className='mr-2'>{this.props.driveInfo.size} KB</p>
                    <div className='flexc mt-3'>
                        <button className='flexc drive-btn1 pld-3 prd-4 py-2 br-10 mx-2' style={{ width: '110px' }}>
                            <img width={20} src='/assets/icons/drive/download-drive.svg' />
                            <p className='pld-3'>Download</p>
                        </button>
                        <button className='flexcc drive-btn2 pld-3 prd-4 py-2 br-10 mx-2' style={{ width: '110px' }} onClick={() => this.onShareModal()}>
                            <img width={20} src='/assets/icons/drive/share-purple.svg' />
                            <p className='pld-3'>Share</p>
                        </button>
                    </div>
                </div>
                <Modal maxWidth={400} ref={(shareModal) => this.confirmshareModal = shareModal}  >
                    <div className='w-100 h-100 bg-white br-10 p-3'>
                        <div className="w-100 flexcb">
                            <p className='main-c2 font-size-14 weight-500'>Share the file / folder</p>
                            <div className='flexc'>
                                <button className='mx-2'>
                                    <img className='flexcc' width={20} src='/assets/icons/drive/help-gray.svg' />
                                </button>
                                <button className=''>
                                    <img className='flexcc' width={20} src='/assets/icons/drive/setting-gray.svg' />
                                </button>
                            </div>
                        </div>
                        <div className='flexcc mt-2 purple-box-border-h p-2 br-10'>
                            <TextInput data={this.state.viewName} changeValue={this.changeValue} header={{ key: 'viewName', information: { rows: 1, placeholder: translate('Add Users or Groups') }, }} />
                        </div>
                        <div className='mt-3'>
                            <p className='font-size-14 main-c2'>People with access</p>
                            <div className='mt-2'>
                                {this.state.access.map((prop, index) => {
                                    return (
                                        <button className='flexcb w-100 hover-gray2 p-2 br-10'>
                                            <div className='flexc'>
                                                <img width={35} className='br-50' src={prop.img} />
                                                <div className='text-start mld-3'>
                                                    <p className='font-size-14 main-c2'>{prop.name}</p>
                                                    <p className='font-size-10 main-c7'>{prop.username}</p>
                                                </div>
                                            </div>
                                            <p className='font-size-10 main-c5'>{prop.role}</p>
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                        <div className='mt-3'>
                            <p className='font-size-14 main-c2'>General access</p>
                            <div className='mt-2'>
                                <button className='flexcb w-100 hover-gray2 p-2 br-10'>
                                    <div className='flexc'>
                                        <div className='flexcc br-50' style={{ backgroundColor: '#6B00B6', width: 35, height: 35 }}>
                                            <img width={30} className='br-50 flexcc' src='/assets/icons/drive/network-white.svg' />
                                        </div>
                                        <div className='text-start mld-3'>
                                            <p className='font-size-14 main-c2'>Any one with a link</p>
                                            <p className='font-size-10 main-c7'>Anyone on the internet with the link can view</p>
                                        </div>
                                    </div>
                                    <p className='font-size-10 main-c5'>Viewer</p>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}
